import produce from 'immer';

import {
  CONNECT_POST,
  CONNECT_POST_SUCCESS,
  CREATE_COMPETITION_SUCCESS,
  DELETE_COMPETITION_SUCCESS,
  FETCH_COMPETITION_POSTS,
  FETCH_COMPETITION_POSTS_SUCCESS,
  FETCH_COMPETITIONS_SUCCESS,
  UPDATE_COMPETITION,
  UPDATE_COMPETITION_SUCCESS,
} from 'actions/competitionActions';

export const initialState = {
  fetching: false,
  fetchSuccess: false,
  fetchFailed: false,
  statusText: null,
  submitting: false,
  createSuccess: false,
  createFailed: false,
  createError: '',
  current: null,
  posts: [],
  list: [],
  statuses: {
    all: 0,
    mine: 0,
    trash: 0,
    draft: 0,
    finished: 0,
    deactivated: 0,
    published: 0,
    scheduled: 0,
  },
};

/* eslint-disable default-case, no-param-reassign */
const competitionReducer = (state = initialState, action) =>
  // eslint-disable-next-line consistent-return
  produce(state, (draft) => {
    switch (action.type) {
      case FETCH_COMPETITIONS_SUCCESS:
        draft.list = action.competitions;
        draft.current = draft.list.find((c) => c.current);
        draft.fetchSuccess = true;
        break;

      case CREATE_COMPETITION_SUCCESS:
        draft.list.push(action.competition);
        break;

      case UPDATE_COMPETITION:
        draft.submitting = true;
        draft.createSuccess = false;
        break;

      case UPDATE_COMPETITION_SUCCESS:
        draft.submitting = false;
        draft.createSuccess = true;
        draft.list = draft.list.map((com) =>
          com._id === action.competition._id ? action.competition : com
        );
        break;

      case DELETE_COMPETITION_SUCCESS:
        draft.list = draft.list.filter((com) => com._id !== action.competition);
        break;

      case CONNECT_POST:
        draft.submitting = true;
        draft.createSuccess = false;
        break;
      case CONNECT_POST_SUCCESS:
        draft.submitting = false;
        draft.createSuccess = true;
        draft.posts = draft.posts.map((p) =>
          p._id === action.postId
            ? {
                ...p,
                competitionId: action.remove ? null : action.competition._id,
              }
            : p
        );

        break;

      case FETCH_COMPETITION_POSTS:
        draft.fetching = true;
        draft.fetchSuccess = false;
        draft.fetchFailed = false;
        break;
      case FETCH_COMPETITION_POSTS_SUCCESS:
        draft.fetching = false;
        draft.fetchSuccess = true;
        draft.fetchFailed = false;
        draft.posts = action.posts;
        draft.statuses = action.statuses;
        break;
    }
  });

export default competitionReducer;
